var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_NoSubmit_SR"),
                  name: "unSubmitted"
                }
              },
              [
                _c("tab-un-submitted", {
                  attrs: { source: "unSubmitted", "config-model": "190806" }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_AwaitApproval_SR"),
                  name: "approving",
                  lazy: true
                }
              },
              [
                _c("tab-approving", {
                  attrs: { source: "approving", "config-model": "190807" }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_Approved_SR"),
                  name: "approved",
                  lazy: true
                }
              },
              [
                _c("tab-approved", {
                  attrs: { source: "approved", "config-model": "190808" }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }